var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.error)?_c('span',{staticClass:"has-text-warning"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}})],1):_vm._e(),_vm._v(" "),_c('span',{class:{ 'badge is-badge-danger' : _vm.downCount > 0 },attrs:{"data-badge":_vm.downCount}},[_vm._v("\n    Applications\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b48c98c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/applications/handle.vue
// module id = null
// module chunks = 